export default "__VITE_ASSET__BI1TrLXN__"